import React from 'react';
import { StyledHeaderContainer, StyledPaperContainer } from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import useClinicMasterProductForm from '../../hooks/useClinicMasterProductForm';
import { ExistingClinicMasterProduct } from '../../../../apis/clinic-master-products/types';
import { ColumnWithGap } from '../../../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import ClinicMasterProductMasterMedicineSelectorEditor from '../Editors/ClinicMasterProductMasterMedicineSelectorEditor';
import ClinicVirtualProductEditor from '../../../ClinicProduct/components/Editors/ClinicProductsTableEditor';
import useClinicProductsForm from '../../../ClinicProduct/hooks/useClinicProductForm';
import { ClinicProduct } from '../../../../apis/clinic-products/types';
import { ModifyClinicMasterProductFooter } from './ModifyClinicMasterProductFooter';
import usePutClinicProductsInForm from '../hooks/usePutClinicProductsInForm';
import ClinicMasterProductDeliveryPriceEditor from '../Editors/ClinicMasterProductDeliveryPriceEditor';
import ClinicProductPharmacyPercentageEditor from '../../../ClinicProduct/components/ClinicProductPharmacyPercentageEditor';
import styled from 'styled-components';
import useClinicById from '../../../Clinics/ModifyClinic/hooks/useClinicById';
import GlobalDefaultClinicBanner from '../../../Clinics/ModifyClinic/components/GlobalDefaultClinicBanner';

interface ClinicMasterProductProps {
  clinicId: string;
  clinicMasterProduct: ExistingClinicMasterProduct;
  clinicProducts: ClinicProduct[];
}

const ModifyClinicMasterProduct = ({ clinicId, clinicMasterProduct, clinicProducts }: ClinicMasterProductProps) => {
  const form = useClinicMasterProductForm(clinicMasterProduct);
  const { clinic } = useClinicById(clinicId);

  const productsForm = useClinicProductsForm(clinicProducts);

  usePutClinicProductsInForm(productsForm, clinicProducts);

  const isGlobalDefaultClinic = clinic?.selection_visibility === 'global_default';

  return (
    <ColumnWithGap>
      <StyledHeaderContainer>{clinicMasterProduct.master_medicine?.name}</StyledHeaderContainer>
      
      {isGlobalDefaultClinic && clinic && (
        <GlobalDefaultClinicBanner />
      )}
      
      <StyledPaperContainer>
        <ColumnWithGap>
          <ClinicMasterProductMasterMedicineSelectorEditor form={form} />
          <InputsRowContainer>
            <div>
              <ClinicMasterProductDeliveryPriceEditor form={form} />
            </div>
            <div>
              <ClinicProductPharmacyPercentageEditor form={productsForm} masterProductForm={form} />
            </div>
          </InputsRowContainer>
          <ClinicVirtualProductEditor form={productsForm} />
        </ColumnWithGap>
      </StyledPaperContainer>
      <ModifyClinicMasterProductFooter
        productsForm={productsForm}
        clinicId={clinicId}
        form={form}
        id={clinicMasterProduct._id}
      />
    </ColumnWithGap>
  );
};

const InputsRowContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 16px;

  & > div {
    flex: 1;
  }

  & > div:first-child {
    padding-right: 16px;
  }

  & > div:last-child {
    padding-left: 16px;
  }
`;

export default ModifyClinicMasterProduct;
